module.exports = __webpack_public_path__ + "static/media/ofuroMatagi.100b6994.png";